import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <section className="py-20 bg-[oklch(0.97_0.01_85)]">
      <div className="container max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[oklch(0.2_0.03_145)] mb-4">
            Common Questions from Calgary Homeowners
          </h2>
          <p className="text-lg text-[oklch(0.4_0.03_145)]">
            Transparent answers to help you make the right decision.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          <AccordionItem value="item-1" className="bg-white border border-[oklch(0.9_0.02_85)] rounded-lg px-6">
            <AccordionTrigger className="text-lg font-bold text-[oklch(0.2_0.03_145)] hover:text-[oklch(0.35_0.12_145)] hover:no-underline py-6">
              What makes you different from other "cash offer" companies?
            </AccordionTrigger>
            <AccordionContent className="text-[oklch(0.4_0.03_145)] leading-relaxed pb-6">
              We are <strong>direct buyers</strong>—local renovators and builders with our own funding. Most "cash offer" companies are actually wholesalers who put your home under contract and then shop it around to find a real buyer, charging $10k-$25k assignment fees. We don't do that. We are the actual buyer, which means we can offer <strong>unconditional offers</strong> with no financing conditions and <strong>same-day pricing</strong> on our first visit.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-2" className="bg-white border border-[oklch(0.9_0.02_85)] rounded-lg px-6">
            <AccordionTrigger className="text-lg font-bold text-[oklch(0.2_0.03_145)] hover:text-[oklch(0.35_0.12_145)] hover:no-underline py-6">
              What does "unconditional offer" mean?
            </AccordionTrigger>
            <AccordionContent className="text-[oklch(0.4_0.03_145)] leading-relaxed pb-6">
              An unconditional offer means there are <strong>no conditions</strong> that could cause the deal to fall through. No financing conditions (we have our own capital), no inspection conditions (we buy as-is), no "subject to finding a buyer" clauses. When we make an offer, we commit. This is something most cash offer companies simply cannot do because they need to find another buyer first.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-3" className="bg-white border border-[oklch(0.9_0.02_85)] rounded-lg px-6">
            <AccordionTrigger className="text-lg font-bold text-[oklch(0.2_0.03_145)] hover:text-[oklch(0.35_0.12_145)] hover:no-underline py-6">
              How do you calculate your offer price?
            </AccordionTrigger>
            <AccordionContent className="text-[oklch(0.4_0.03_145)] leading-relaxed pb-6">
              We work backwards from the future value of the home. We look at what the house will be worth after we renovate it (or build a new one). Then we subtract the construction costs, holding costs, and a fair profit margin. What's left is your offer. We show you this breakdown openly so you know exactly where the number comes from.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-4" className="bg-white border border-[oklch(0.9_0.02_85)] rounded-lg px-6">
            <AccordionTrigger className="text-lg font-bold text-[oklch(0.2_0.03_145)] hover:text-[oklch(0.35_0.12_145)] hover:no-underline py-6">
              Do you offer creative financing options?
            </AccordionTrigger>
            <AccordionContent className="text-[oklch(0.4_0.03_145)] leading-relaxed pb-6">
              Yes! Because we're direct buyers with our own capital, we have flexibility that other companies don't. Need to clear debt before closing? Want a leaseback arrangement so you can stay in the home temporarily? We can structure offers to fit your unique situation. Just let us know what you need during our visit.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-5" className="bg-white border border-[oklch(0.9_0.02_85)] rounded-lg px-6">
            <AccordionTrigger className="text-lg font-bold text-[oklch(0.2_0.03_145)] hover:text-[oklch(0.35_0.12_145)] hover:no-underline py-6">
              Do I need to clean or repair anything before selling?
            </AccordionTrigger>
            <AccordionContent className="text-[oklch(0.4_0.03_145)] leading-relaxed pb-6">
              Absolutely not. We buy your home "as-is." You don't need to paint, fix the roof, or even sweep the floors. Take what you want to keep, and leave the rest behind—even old furniture or junk. We handle the cleanout and all repairs ourselves.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-6" className="bg-white border border-[oklch(0.9_0.02_85)] rounded-lg px-6">
            <AccordionTrigger className="text-lg font-bold text-[oklch(0.2_0.03_145)] hover:text-[oklch(0.35_0.12_145)] hover:no-underline py-6">
              How fast can we close?
            </AccordionTrigger>
            <AccordionContent className="text-[oklch(0.4_0.03_145)] leading-relaxed pb-6">
              We can close as quickly as 7 days if you're in a rush, or we can wait 90+ days if you need time to find your next place. Because we use our own funds and don't rely on bank financing approvals, the timeline is completely up to you.
            </AccordionContent>
          </AccordionItem>

          <AccordionItem value="item-7" className="bg-white border border-[oklch(0.9_0.02_85)] rounded-lg px-6">
            <AccordionTrigger className="text-lg font-bold text-[oklch(0.2_0.03_145)] hover:text-[oklch(0.35_0.12_145)] hover:no-underline py-6">
              Is there any cost or obligation to get an offer?
            </AccordionTrigger>
            <AccordionContent className="text-[oklch(0.4_0.03_145)] leading-relaxed pb-6">
              None at all. Our visits are free, friendly, and 100% confidential. We'll give you a fair written offer on the spot, and you can take as much time as you need to think about it. We never use high-pressure sales tactics.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
}
